import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import "./reset.css";
import "./index.css";
import Context from "./Context";
import App from "./App";

ReactDOM.render(
  <Context>
    <Router>
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </Router>
  </Context>,
  document.getElementById("root")
);
